import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lt-png-table-action-footer',
  imports: [CommonModule],
  template: `
    <div class="footer-info">
        <small class="text-muted">
            <i class="pi pi-list me-1"></i>
            {{ rowCount() }} {{ getRowLabel() }}
        </small>
    </div>
  `,
})
export class LTPngTableActionFooterComponent {
  rowCount = input.required<number>();
  
  getRowLabel(): string {
    return this.rowCount() === 1 ? 'row' : 'rows';
  }
}
